import React from "react";

const BottomFooter = () => {
  return (
    <div className="font-bold text-base text-center border-t-[1px] border-Gray04 py-6">
      <p className="text-Gray01">Copyright © 2023 ADVENTOUR. </p>
    </div>
  );
};

export default BottomFooter;
